import { type RootState } from "@/types/app";

export const selectAccountSlice = (state: RootState) => state.app.me;
